<template>
  <VueTypeaheadBootstrap
    v-model="search"
    @hit="input_value = $event"
    :data="parceiros"
    :serializer="(item) => item.text"
    :placeholder="placeholder"
    :class="[stateClass]"
    :showOnFocus="true"
    :size="size"
  />
</template>

<script>
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import { mapActions } from "vuex";

import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/src/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/src/mixins/form-state";

import { sortKeys } from "bootstrap-vue/src/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/src/utils/props";
import _ from "lodash";

const props = makePropsConfigurable(
  sortKeys({
    ...formStateProps,
    ...formControlProps,
    value: {
      default: null,
    },
    return_object: false,
    placeholder: {
      type: String,
      default: "Parceiros",
    },
    size: {
      type: String,
      default: "md",
    },
  })
);

export default {
  components: { VueTypeaheadBootstrap },
  mixins: [formControlMixin, formStateMixin],
  props,
  data: () => ({
    search: "",
    input_value: null,
    parceiros: [],
  }),
  computed: {},
  methods: {
    ...mapActions("parceiros", ["ActionToSelect"]),
    setById(id) {
      let selected = _.find(this.parceiros, { value: id });
      if (selected) {
        this.search = selected.text;
        this.input_value = selected;
      }
    },
  },
  watch: {
    search: function (value) {
      if (value === "") {
        this.$emit("input", null);
      }
    },
    input_value() {
      if (this.return_object) {
        this.$emit("input", this.input_value);
      } else {
        this.$emit("input", this.input_value.value);
      }
    },
    value: function (value, old) {
      this.setById(value);
    },
  },
  async created() {
    this.parceiros = await this.ActionToSelect();
    if (this.value) {
      this.setById(this.value);
    }
  },
};
</script>

<style lang="scss">
.form-control-custom {
  margin-left: 0;
  padding-left: 0;
  padding-top: 0;

  .form-control {
    border: none !important;
    background: transparent !important;
  }
}
</style>
